import Plausible from 'plausible-tracker'

export const plausible = Plausible({
  trackLocalhost: false,
  hashMode: true,
  domain: window.location.hostname,
})
